"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDrawer = exports.Root = exports.HeaderContainer = exports.CloseButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const HeaderContainer = exports.HeaderContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  userSelect: 'none',
  padding: theme.spacing(0, 2, 4)
}));
const Root = exports.Root = (0, _mui.styled)(_mui.Paper, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['hasFooter'])
})(({
  theme,
  hasFooter
}) => ({
  display: 'flex',
  justifyItems: 'center',
  flexDirection: 'column',
  position: 'relative',
  width: 400,
  outline: 0,
  padding: hasFooter ? theme.spacing(6, 0, 0) : theme.spacing(6, 0),
  overflow: 'hidden',
  height: '100%',
  borderRadius: 0
}));
const CloseButton = exports.CloseButton = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  padding: theme.spacing(1.4),
  margin: theme.spacing(2),
  background: (0, _mui.alpha)(theme.palette.common.white, 0.75)
}));
const StyledDrawer = exports.StyledDrawer = (0, _mui.styled)(_mui.Drawer, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['zIndex'])
})(({
  zIndex
}) => ({
  zIndex
}));
//# sourceMappingURL=styles.js.map